import type { OptionsDocument } from 'paintscout'
import { getLeadSources } from './get-lead-sources/get-lead-sources'

export function hasLeadSources(options?: OptionsDocument): boolean {
  if (!options) {
    return false
  }

  return getLeadSources({ options, type: 'leadSources' }).length > 0
}
